<div class="pest-details-line"
  [style.border-left-width]="'2px'"
  [style.border-left-style]="'solid'"
  [style.border-left-color]="'#BF23D7'"
>
  <div class="increase-container">
    <span class="title">
      {{'doktar_app.home.pest_risk.total_pests' | translate}}
    </span>
    <span class="inrease-info" [style.color]="'#BF23D7'">
      {{ (pestRisk.pestCount - pestRisk.increase) }} 
      <i class="ph-bold ph-arrow-right"></i>
      {{ pestRisk.pestCount }}
    </span>
    <span class="increase-footer">
      {{ pestRisk.increase > 1 
        ? ('doktar_app.home.pest_risk.pests_increased' | translate: { arg1: pestRisk.increase }) 
        : ('doktar_app.home.pest_risk.pest_increased' | translate: { arg1: pestRisk.increase }) }}
    </span>
  </div>
</div>
